import { render, staticRenderFns } from "./nav-left.vue?vue&type=template&id=0687b3fc"
import script from "./nav-left.vue?vue&type=script&lang=js"
export * from "./nav-left.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports